export function formatArray(arr: string[]) {
  return arr.concat(Array(3).fill('-', arr.length));
}
